/* ברלניק - חיפוש חכם (מוצרים + קטגוריות), עיצוב לפי החיפוש של בול פרקט */
(function () {
  if (window.__bkSearch) return; window.__bkSearch = 1;

  var C = { navy: '#0d1b3a', navyHover: '#1c2f5c', tint: '#e9eef8', line: '#e6e3dc', soft: '#f5f3ee', muted: '#7a7f88' };
  var POPULAR = ['מברגה', 'דבק', 'סיליקון', 'ספריי צבע', 'משחזת זווית', 'מקדחים', 'סרט הדבקה', 'שמן לעץ', 'איטום', 'ניקוי פרקט'];
  var WA = 'https://wa.me/972522083237';
  var IDX_KEY = 'bksi_v1', TTL = 6 * 3600 * 1000;

  var css = '' +
    '.predictive-search{display:none!important}' +
    '.bpsr-pan{position:fixed;z-index:100000;display:none;background:#fff;border:1px solid ' + C.line + ';border-radius:16px;box-shadow:0 18px 50px rgba(13,27,58,.2);direction:rtl;text-align:right;overflow-y:auto;overscroll-behavior:contain;font-size:15px;color:#1c2330;padding:4px 0 6px;font-family:inherit}' +
    '.bpsr-pan.on{display:block}' +
    '.bpsr-pan .bpsr-sec{padding:10px 16px 4px;font-size:12px;font-weight:700;color:' + C.muted + '}' +
    '.bpsr-pan .bpsr-row{display:flex;align-items:center;gap:12px;padding:8px 16px;line-height:1.35;text-decoration:none!important;color:#1c2330!important;cursor:pointer}' +
    '.bpsr-pan .bpsr-row:hover,.bpsr-pan .bpsr-row.act{background:' + C.soft + '}' +
    '.bpsr-pan .bpsr-row img,.bpsr-pan .bpsr-ph{width:52px;height:52px;border-radius:10px;object-fit:contain;flex:0 0 auto;background:#f4f2ed;display:block}' +
    '.bpsr-pan .bpsr-cat img,.bpsr-pan .bpsr-cat .bpsr-ph{width:38px;height:38px;border-radius:9px}' +
    '.bpsr-pan .bpsr-tx{flex:1 1 0%;min-width:0;display:block}' +
    '.bpsr-pan .bpsr-nm{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;font-size:14.5px}' +
    '.bpsr-pan .bpsr-cat .bpsr-nm{font-weight:700}' +
    '.bpsr-pan .bpsr-nm mark{background:' + C.tint + ';color:' + C.navy + ';font-weight:700;padding:0;border-radius:3px}' +
    '.bpsr-pan .bpsr-sub{display:block;font-size:12.5px;color:' + C.muted + ';margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
    '.bpsr-pan .bpsr-pr{flex:0 0 auto;font-weight:800;color:' + C.navy + ';white-space:nowrap;font-size:14px;text-align:left}' +
    '.bpsr-pan .bpsr-pr s{display:block;font-weight:400;font-size:12px;color:' + C.muted + '}' +
    '.bpsr-pan .bpsr-pr.bpsr-sale{color:#b3261e}' +
    '.bpsr-pan .bpsr-oos{display:inline-block;font-size:11.5px;color:#b3261e;margin-inline-start:6px}' +
    '.bpsr-pan .bpsr-go{flex:0 0 auto;color:' + C.navy + ';font-size:20px;font-weight:700}' +
    '.bpsr-pan .bpsr-all{justify-content:center;margin:8px 12px 4px;padding:11px 14px;border-radius:999px;background:' + C.navy + ';font-weight:700;font-size:14.5px;color:#fff!important}' +
    '.bpsr-pan .bpsr-all:hover,.bpsr-pan .bpsr-all.act{background:' + C.navyHover + '}' +
    '.bpsr-pan .bpsr-chips{display:flex;flex-wrap:wrap;gap:8px;padding:6px 16px 10px}' +
    '.bpsr-pan .bpsr-chip{border:1px solid ' + C.line + ';background:#f6f4ee;color:' + C.navy + ';border-radius:999px;padding:6px 12px;font-size:13.5px;font-weight:600;cursor:pointer;line-height:1.3;font-family:inherit}' +
    '.bpsr-pan .bpsr-chip:hover{border-color:' + C.navy + ';background:#fff}' +
    '.bpsr-pan .bpsr-none{padding:16px 16px 6px}' +
    '.bpsr-pan .bpsr-none b{display:block;font-size:15.5px;margin-bottom:3px}' +
    '.bpsr-pan .bpsr-none span{color:#5b6070;font-size:14px}' +
    '.bpsr-pan .bpsr-cta{display:flex;gap:8px;margin-top:10px}' +
    '.bpsr-pan .bpsr-cta a{flex:1 1 0%;text-align:center;border-radius:999px;padding:9px 12px;font-weight:700;font-size:14px;background:' + C.tint + ';text-decoration:none!important;color:' + C.navy + '!important}' +
    '.bpsr-pan .bpsr-load{padding:18px 16px;color:#5b6070}' +
    '@media (max-width:767px){.bpsr-pan .bpsr-row img,.bpsr-pan .bpsr-ph{width:46px;height:46px}.bpsr-pan .bpsr-row{padding:8px 12px;gap:10px}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  /* ---------- נתונים ---------- */
  var IDX = null, loading = null;
  function cacheGet() {
    try { var o = JSON.parse(localStorage.getItem(IDX_KEY) || 'null'); if (o && Date.now() - o.t < TTL) return o; } catch (e) {}
    return null;
  }
  function cacheSet(o) { try { localStorage.setItem(IDX_KEY, JSON.stringify(o)); } catch (e) {} }
  function getJSON(u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) { return JSON.parse(t.trim()); }); }
  function load() {
    if (IDX) return Promise.resolve(IDX);
    if (loading) return loading;
    var c = cacheGet(); if (c) { IDX = prep(c); return Promise.resolve(IDX); }
    loading = Promise.all([
      getJSON('/collections?view=bk-search-cats'),
      getJSON('/collections/all?view=bk-search-index&page=1').then(function (first) {
        var all = first.p, n = first.pages || 1, reqs = [];
        for (var i = 2; i <= n; i++) reqs.push(getJSON('/collections/all?view=bk-search-index&page=' + i));
        return Promise.all(reqs).then(function (rest) { rest.forEach(function (r) { all = all.concat(r.p); }); return all; });
      })
    ]).then(function (res) {
      var o = { t: Date.now(), c: res[0], p: res[1] }; cacheSet(o); IDX = prep(o); return IDX;
    }).catch(function () { loading = null; return null; });
    return loading;
  }

  function norm(s) {
    return (s || '').toLowerCase()
      .replace(/[֑-ׇ]/g, '')
      .replace(/ך/g, 'כ').replace(/ם/g, 'מ').replace(/ן/g, 'נ').replace(/ף/g, 'פ').replace(/ץ/g, 'צ')
      .replace(/["'״׳`]/g, '').replace(/[-_/\\.,()+]/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function prep(o) {
    var cats = (o.c || []).filter(function (c) { return c[2] > 0 && !/\/(all|frontpage)$/.test(c[1]); }).map(function (c) {
      return { t: c[0], u: c[1], n: c[2], i: c[3], h: norm(c[0]) };
    });
    var prods = (o.p || []).map(function (p) {
      return { t: p[0], u: p[1], i: p[2], pr: p[3], cp: p[4], v: p[5], a: p[6], ty: p[7], ve: p[8], sk: p[9],
        ht: norm(p[0]), hx: norm([p[7], p[8], p[9], p[10]].join(' ')) };
    });
    return { cats: cats, prods: prods };
  }

  var PFX = /^[ובהלמשכ]/;
  function variants(tok) {
    var v = [tok];
    if (tok.length >= 5 && /(ימ|ות)$/.test(tok)) v.push(tok.slice(0, -2));
    if (tok.length >= 4 && PFX.test(tok)) { v.push(tok.slice(1)); var s = tok.slice(1); if (s.length >= 5 && /(ימ|ות)$/.test(s)) v.push(s.slice(0, -2)); }
    return v;
  }
  function tokScore(tok, title, extra) {
    var vs = variants(tok), best = 0;
    for (var i = 0; i < vs.length; i++) {
      var w = vs[i], pos = title.indexOf(w), sc = 0;
      if (pos === 0) sc = 30; else if (pos > 0) sc = title.charAt(pos - 1) === ' ' ? 22 : 12;
      else if (extra && extra.indexOf(w) >= 0) sc = 6;
      if (i > 0 && sc) sc -= 3;
      if (sc > best) best = sc;
    }
    return best;
  }
  function score(toks, q, title, extra) {
    var s = 0;
    for (var i = 0; i < toks.length; i++) { var k = tokScore(toks[i], title, extra); if (!k) return 0; s += k; }
    if (title.indexOf(q) === 0) s += 40; else if (title.indexOf(q) > 0) s += 20;
    return s - title.length / 40;
  }
  function search(q) {
    var nq = norm(q), toks = nq.split(' ').filter(Boolean);
    if (!toks.length) return null;
    var cats = [], prods = [];
    IDX.cats.forEach(function (c) { var s = score(toks, nq, c.h, ''); if (s > 0) cats.push([s + Math.log(c.n + 1), c]); });
    IDX.prods.forEach(function (p) { var s = score(toks, nq, p.ht, p.hx); if (s > 0) prods.push([s + (p.a ? 15 : 0), p]); });
    cats.sort(function (a, b) { return b[0] - a[0]; }); prods.sort(function (a, b) { return b[0] - a[0]; });
    return { toks: toks, cats: cats.slice(0, 4).map(function (x) { return x[1]; }), prods: prods.slice(0, 6).map(function (x) { return x[1]; }), total: prods.length };
  }

  /* ---------- תצוגה ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function hl(text, q) {
    var words = q.trim().split(/\s+/).filter(function (w) { return w.length > 0; }).map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); });
    var h = esc(text); if (!words.length) return h;
    try { return h.replace(new RegExp('(' + words.join('|') + ')', 'gi'), '<mark>$1</mark>'); } catch (e) { return h; }
  }
  function money(c) { var n = c / 100; return '₪' + (n % 1 ? n.toFixed(2) : n.toLocaleString('he-IL')); }
  function img(u, cls) { return u ? '<img src="' + esc(u) + '" alt="" loading="lazy">' : '<span class="bpsr-ph"></span>'; }
  function allUrl(q) { return '/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last'; }

  var pan = document.createElement('div'); pan.className = 'bpsr-pan'; pan.setAttribute('role', 'listbox');
  document.body.appendChild(pan);
  var cur = null, timer = null, act = -1;

  function place() {
    if (!cur) return;
    var box = (cur.closest('form') || cur).getBoundingClientRect(), vw = window.innerWidth, vh = window.innerHeight;
    var mobile = vw < 768, w = mobile ? vw - 16 : Math.min(Math.max(box.width, 420), 560);
    var right = mobile ? 8 : Math.max(8, vw - box.right);
    if (vw - right - w < 8) right = Math.max(8, vw - w - 8);
    var top = box.bottom + 8;
    pan.style.top = top + 'px'; pan.style.right = right + 'px'; pan.style.width = w + 'px';
    pan.style.maxHeight = Math.max(220, vh - top - 12) + 'px';
  }
  function open(html) { pan.innerHTML = html; act = -1; place(); pan.classList.add('on'); }
  function close() { pan.classList.remove('on'); act = -1; }

  function renderEmpty() {
    open('<div class="bpsr-sec">חיפושים פופולריים</div><div class="bpsr-chips">' +
      POPULAR.map(function (p) { return '<button type="button" class="bpsr-chip" data-q="' + esc(p) + '">' + esc(p) + '</button>'; }).join('') + '</div>');
  }
  function render(q) {
    if (!IDX) { open('<div class="bpsr-load">טוען תוצאות…</div>'); return; }
    var r = search(q); if (!r) { renderEmpty(); return; }
    var h = '';
    if (r.cats.length) {
      h += '<div class="bpsr-sec">קטגוריות</div>';
      r.cats.forEach(function (c) {
        h += '<a class="bpsr-row bpsr-cat" href="' + esc(c.u) + '">' + img(c.i) + '<span class="bpsr-tx"><span class="bpsr-nm">' + hl(c.t, q) +
          '</span><span class="bpsr-sub">' + c.n + ' מוצרים</span></span><span class="bpsr-go">‹</span></a>';
      });
    }
    if (r.prods.length) {
      h += '<div class="bpsr-sec">מוצרים</div>';
      r.prods.forEach(function (p) {
        var sale = p.cp > p.pr;
        h += '<a class="bpsr-row" href="' + esc(p.u) + '">' + img(p.i) + '<span class="bpsr-tx"><span class="bpsr-nm">' + hl(p.t, q) +
          '</span><span class="bpsr-sub">' + esc(p.ty || '') + (p.a ? '' : '<span class="bpsr-oos">אזל במלאי</span>') + '</span></span>' +
          '<span class="bpsr-pr' + (sale ? ' bpsr-sale' : '') + '">' + (p.v ? 'החל מ-' : '') + money(p.pr) + (sale ? '<s>' + money(p.cp) + '</s>' : '') + '</span></a>';
      });
      h += '<a class="bpsr-row bpsr-all" href="' + allUrl(q) + '">לכל ' + r.total + ' התוצאות עבור "' + esc(q.trim()) + '"</a>';
    }
    if (!r.cats.length && !r.prods.length) {
      h = '<div class="bpsr-none"><b>לא מצאנו תוצאות עבור "' + esc(q.trim()) + '"</b><span>נסו מילה אחרת או קצרה יותר, או כתבו לנו ונמצא בשבילכם.</span>' +
        '<div class="bpsr-cta"><a href="/collections/all">לכל הקטלוג</a><a href="' + WA + '" target="_blank" rel="noopener">שאלו אותנו בוואטסאפ</a></div></div>' +
        '<div class="bpsr-sec">חיפושים פופולריים</div><div class="bpsr-chips">' +
        POPULAR.slice(0, 6).map(function (p) { return '<button type="button" class="bpsr-chip" data-q="' + esc(p) + '">' + esc(p) + '</button>'; }).join('') + '</div>';
    }
    open(h);
  }
  function run() {
    if (!cur) return;
    var q = cur.value;
    if (!q.trim()) { renderEmpty(); return; }
    if (IDX) { render(q); return; }
    render(q); load().then(function () { if (cur && cur.value === q) render(q); });
  }

  function isSearch(el) { return el && el.tagName === 'INPUT' && el.name === 'q' && el.form && /\/search/.test(el.form.getAttribute('action') || ''); }
  document.addEventListener('focusin', function (e) {
    if (!isSearch(e.target)) return;
    cur = e.target; load(); run();
  });
  document.addEventListener('input', function (e) {
    if (e.target !== cur) return;
    clearTimeout(timer); timer = setTimeout(run, 70);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.target !== cur || !pan.classList.contains('on')) return;
    var rows = pan.querySelectorAll('.bpsr-row');
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault(); if (!rows.length) return;
      act = e.key === 'ArrowDown' ? (act + 1) % rows.length : (act <= 0 ? rows.length - 1 : act - 1);
      rows.forEach(function (r, i) { r.classList.toggle('act', i === act); });
      rows[act].scrollIntoView({ block: 'nearest' });
    } else if (e.key === 'Enter' && act >= 0 && rows[act]) {
      e.preventDefault(); location.href = rows[act].href;
    } else if (e.key === 'Escape') { close(); }
  }, true);
  pan.addEventListener('mousedown', function (e) { e.preventDefault(); });
  pan.addEventListener('click', function (e) {
    var chip = e.target.closest('.bpsr-chip');
    if (chip && cur) { cur.value = chip.getAttribute('data-q'); cur.focus(); run(); }
  });
  document.addEventListener('mousedown', function (e) { if (cur && e.target !== cur && !pan.contains(e.target)) close(); });
  document.addEventListener('touchstart', function (e) { if (cur && e.target !== cur && !pan.contains(e.target)) close(); }, { passive: true });
  window.addEventListener('resize', place);
  window.addEventListener('scroll', function () { if (pan.classList.contains('on')) place(); }, { passive: true });

  /* טעינה מוקדמת בזמן מת, כדי שהתוצאות יופיעו מיד */
  var idle = window.requestIdleCallback || function (f) { setTimeout(f, 2500); };
  idle(function () { load(); });
})();
